<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content" v-if="data">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
					<h4 class="modal-title">Ordenar subcategorías {{ data.title }}</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="list-group list-group-full">
								<draggable
									:options="draggableOptions"
									v-model="categories"
									@change="changeSort">
									<li
										v-for="(category, key) in categories"
										:class="{ 'disabled' : loading }"
										class="list-group-item link">
										{{ category.title }} - {{ category.sort }}
									</li>
								</draggable>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import draggable from 'vuedraggable'
	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
			draggable,
		},
		data () {
			return {
				modal: {
					selector: 'category-sort-' + new Date().getTime()
				},

				categories: null,

				loading: false,
				draggableOptions: {
					disabled: false,
				}
			}
		},
		watch: {
			loading() {
				if(this.loading) {
					this.draggableOptions.disabled = true
				} else {
					this.draggableOptions.disabled = false
				}
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				//
			},
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
				this.loadCategories()
			},
			loadCategories() {
				this.categories = null
				if(this.data.sub_categories) {
					if(this.data.sub_categories) {
						this.categories = JSON.parse(JSON.stringify(this.data.sub_categories))
					}
				}
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			changeSort(data) {
				this.loading = true
				var moved = data.moved

				var category_1 = this.categories[moved.newIndex]
				var category_2 = this.categories[moved.oldIndex]

				var move = null
				if(moved.newIndex > moved.oldIndex) {
					move = 'down'
				} else {
					if(moved.newIndex < moved.oldIndex) {
						move = 'up'
					}
				}

				var category = null
				if(move == 'down') {
					var category = this.categories[moved.newIndex - 1]
					this.$http.get('admin/cms/categories/' + moved.element.id + '/sort/after/' + category.id)
						.then(response => {
							this.$emit('reload')
							this.loading = false
						}).catch(function(response) {
							console.log(response)
							this.loading = false
						})
						
				} else {
					if(move == 'up') {
						var category = this.categories[moved.newIndex + 1]
						this.$http.get('admin/cms/categories/' + moved.element.id + '/sort/before/' + category.id)
							.then(response => {
								this.$emit('reload')
								this.loading = false
							}).catch(function(response) {
								console.log(response)
								this.loading = false
							})
					}
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/cms/categories/views/Sort.vue